import { render, staticRenderFns } from "./ProfileDrawerUser.vue?vue&type=template&id=615a9a02&scoped=true&"
import script from "./ProfileDrawerUser.vue?vue&type=script&lang=js&"
export * from "./ProfileDrawerUser.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDrawerUser.vue?vue&type=style&index=0&id=615a9a02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a9a02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
